<div>
  <p class="p1">
    {{ 'History: ' | trans:'customers/customer-details-modal/cards/history.Label' }}
  </p>

  <div class="m-t-16">
    @if (isLoading()) {
      <div class="d-flex justify-content-center">
        <app-loader />
      </div>
    } @else {
      <table class="base-2">
        <thead>
        <tr class="text-right">
          <th>
            {{ 'Card number' | trans:'customers/customer-details-modal/cards/cardNumber.Label' }}
          </th>
          <th>
            {{ 'Motive' | trans:'customers/customer-details-modal/cards/motive.Label' }}
          </th>
          <th>
            {{ 'Model' | trans:'customers/customer-details-modal/cards/model.Label' }}
          </th>
          <th>
            {{ 'Type of card' | trans:'customers/customer-details-modal/cards/typeOfCard.Label' }}
          </th>
          <th>
            {{ 'Status' | trans:'customers/customer-details-modal/cards/status.Label' }}
          </th>
          <th>
            {{ 'Publisher' | trans:'customers/customer-details-modal/cards/publisher.Label' }}
          </th>
          <th></th>
        </tr>
        </thead>
        <tbody>
          @for (card of data; track card.id) {
            <tr class="text-right">
              <td>
                <p class="p2 c-t-blue-700">
                  {{ card.cardNumber }}
                </p>
              </td>
              <td>
                {{ card.motive | empty }}
              </td>
              <td>
                {{ card.model }}
              </td>
              <td>
                {{ card.cardTypeKey }}
              </td>
              <td>
                <div class="tag card-status--{{ card.statusKey }} to-right">
                  {{ card.statusKey | trans:'customers/customer-details-modal/cards/statusKey.' + card.statusKey }}
                </div>
              </td>
              <td>
                {{ card.distributor }}
              </td>
              <td>
                <div class="d-flex align-items-center justify-content-flex-end">
                  <button
                    class="button button--sm button--primary-ghost d-flex align-items-center gap-8"
                    type="button"
                    [disabled]="isUseCardDisabled()"
                    [title]="!hasActiveBasket() ? ('An active basket is required to use a card.' | trans:'customers/customer-details-modal/cards/noActiveBasket.Message') : ''"
                    (click)="useCard(card)"
                  >
                    <span class="text-uppercase">
                      {{ 'Use Card' | trans:'customers/customer-details-modal/cards/useCard.Button' }}
                    </span>
                    <i class="ri-arrow-right-circle-line"></i>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
</div>
